<template>
  <ModalDialog
    v-if="visible"
    title="评审表"
    :size="modalSize"
    @close="handleCancel"
    @submit="handleSubmit"
  >
    <div class="content">
      <div class="r-box">
        <div class="content-box flex flex-col">
          <div class="target-score">
            <span class="score-item">
              基础总得分:
              <span class="number baseTotalPoints">{{ baseTotalPoints }}</span>
              <span class="score">分</span>
            </span>
            <span class="score-item">
              额外总得分:
              <span class="number extraTotalPoints">{{
                extraTotalPoints
              }}</span>
              <span class="score">分</span>
            </span>
            <span class="score-item">
              总得分:
              <span class="number totalPoints">{{ totalPoints }}</span>
              <span class="score">分</span>
            </span>
          </div>
          <div class="review-content">
            <a-table
              class="table"
              :columns="columns"
              :data-source="reviewData.dataList"
              bordered
              :pagination="false"
              :rowKey="(record) => record.id"
              :scroll="{ x: 540, y: 540 }"
            >
              <span slot="moduleName" slot-scope="text">{{ text }}</span>
              <template slot="scoreCriteria" slot-scope="text">
                <div class="score-criteria">
                  {{ transform(text) }}
                </div>
              </template>
              <template slot="itemScore" slot-scope="text, record">
                <editable-cell
                  :evaluationTablePreview="evaluationTablePreview"
                  :maxBase="record.score"
                  :maxExtra="record.extraScore"
                  :text="record.itemScore || '0'"
                  :extraText="record.itemExtraScore || '0'"
                  @onCellChangeBase="
                    onCellChangeBase(record.id, 'itemScore', $event)
                  "
                  @onCellChangeExtra="
                    onCellChangeExtra(record.id, 'itemExtraScore', $event)
                  "
                />
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
  </ModalDialog>
</template>

<script>
import { getAction, postAction } from "@/api/index";
import EditableCell from "./EditableCell.vue";
import ModalDialog from "./modalDialog.vue";
export default {
  name: "RateTable",
  components: {
    EditableCell,
    ModalDialog,
  },
  data() {
    return {
      evaluationTablePreview: false,
      totalPoints: 0,
      baseTotalPoints: 0,
      extraTotalPoints: 0,
      columns: [
        {
          title: "评价维度",
          dataIndex: "moduleName",
          key: "moduleName",
          align: "center",
          width: 120,
          scopedSlots: {
            customRender: "moduleName",
          },
          customRender: (text, record, index) => {
            const obj = {
              children: record.moduleName,
              attrs: {},
            };
            obj.attrs.rowSpan = this.columnsInit(
              record.moduleName,
              this.reviewData.dataList,
              "moduleName",
              index
            );
            return obj;
          },
        },
        {
          title: "评价指标",
          dataIndex: "moduleSubName",
          key: "moduleSubName",
          align: "center",
        },
        {
          title: "评价要点",
          dataIndex: "scoreCriteria",
          key: "scoreCriteria",
          scopedSlots: {
            customRender: "scoreCriteria",
          },
          align: "center",
        },
        {
          title: "基础分值",
          dataIndex: "score",
          key: "score",
          width: 120,
          align: "center",
        },
        {
          title: "加分分值",
          dataIndex: "extraScore",
          key: "extraScore",
          width: 120,
          align: "center",
        },
        {
          title: "得分",
          dataIndex: "itemScore",
          key: "itemScore",
          align: "center",
          width: 260,
          scopedSlots: {
            customRender: "itemScore",
          },
        },
      ],
      reviewData: {
        remark: "",
        dataList: [],
        hasTwo: false,
      },
      visible: false,
      modalSize: "large",
      baseInfo: null,
      applyType: null,
      confirmLoading: false,
    };
  },
  methods: {
    init(baseInfo, applyType) {
      this.visible = true;
      this.baseInfo = baseInfo;
      this.applyType = applyType;
      this.getReviewTable();
    },
    transform(text) {
      return String(text).replaceAll("\\n", "\n");
    },
    onCellChangeBase(key, dataIndex, value) {
      this.updateScore(key, dataIndex, value, "base");
    },
    onCellChangeExtra(key, dataIndex, value) {
      this.updateScore(key, dataIndex, value, "extra");
    },
    updateScore(key, dataIndex, value, type) {
      const dataSource = [...this.reviewData.dataList];
      const target = dataSource.find((item) => item.id === key);

      if (target) {
        target[dataIndex] = value;
        target.operate = "score";
        this.reviewData.dataList = dataSource;
        // 改变则是评分人评分 非机器，故赋值score区分
        this.calculateTotalScores();
      }
    },
    calculateTotalScores() {
      this.totalPoints = 0;
      this.baseTotalPoints = 0;
      this.extraTotalPoints = 0;

      this.reviewData.dataList.forEach((item) => {
        const baseScore = Number(item.itemScore) || 0;
        const extraScore = Number(item.itemExtraScore) || 0;

        this.totalPoints += baseScore + extraScore;
        this.baseTotalPoints += baseScore;
        this.extraTotalPoints += extraScore;
      });
    },
    async handleSubmit() {
      this.confirmLoading = true;

      try {
        const itemScores = {};
        const itemOperate = {};
        const itemExtraScore = {};

        this.reviewData.dataList.forEach((item) => {
          itemScores[item.itemKey] = Number(item.itemScore) || 0;
          itemOperate[item.itemKey] = item.operate || "";
          itemExtraScore[item.itemKey] = Number(item.itemExtraScore) || 0;
        });

        const params = {
          itemScores,
          itemOperate,
          itemExtraScore,
          applyId: this.baseInfo.id,
        };

        const res = await postAction(
          "/lxbase/lxApplyScoreItem/settingScore",
          params
        );

        if (res.code === 200) {
          this.$message.success("提交成功");
          this.visible = false;
        } else if (res.code === 500) {
          this.$message.error(res.message);
        }
      } catch (error) {
        console.error("提交评分失败:", error);
        this.$message.error("提交失败，请重试");
      } finally {
        this.confirmLoading = false;
      }
    },
    async getReviewTable() {
      try {
        const params = {
          applyType: this.applyType,
          applyId: this.baseInfo.id,
        };

        const res = await getAction(
          "/lxbase/lxApplyScoreItem/tablelist",
          params
        );

        if (res.code === 200) {
          this.reviewData = res.result;
          this.calculateTotalScores();

          if (!this.reviewData.hasTwo) {
            this.columns = this.columns.filter(
              (item) => item.title !== "评价维度"
            );
          }
        }
      } catch (error) {
        console.error("获取评审表数据失败:", error);
        this.$message.error("获取评审表数据失败");
      }
    },
    columnsInit(text, data, key, index) {
      if (index !== 0 && text == data[index - 1][key]) {
        return 0;
      }

      let rowSpan = 1; //判断下一行是否相等
      for (let i = index + 1; i < data.length; i++) {
        if (text !== data[i][key]) {
          break;
        }
        rowSpan++;
      }
      return rowSpan;
    },
    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.rate-table-modal {
  ::v-deep .ant-modal-title {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
  }
  // ::v-deep .ant-modal-wrap {
  //   width: 60%;
  //   height: 834px;
  //   overflow: hidden;
  // }
}

.content-box {
  background-color: #fff;
}

.target-score {
  margin-bottom: 7px;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #474747;

  .score-item {
    margin-left: 30px;

    .number {
      font-size: 20px;
      //color: #1164d7;
      //font-weight: bold;
      &.extraTotalPoints {
        color: #38b723;
      }
      &.totalPoints {
        color: #ff7800;
      }
    }

    .score {
      //color: #1164d7;
    }
  }
}

.review-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding-bottom: 10px;

  .table {
    ::v-deep .ant-table-thead > tr > th {
      font-size: 18px !important;
      font-weight: bold;
      background-color: #f0f6ff;
    }

    ::v-deep .ant-table-tbody > tr > td {
      height: auto;
      font-size: 18px;
      padding: 15px !important;
      min-height: 80px;
      box-sizing: border-box;
    }
  }
}

.score-criteria {
  white-space: pre-line;
  text-align: left;
  font-size: 18px;
  line-height: 28px;
}

// EditableCell组件样式
::v-deep .editable-cell {
  height: auto;
  min-height: 50px;

  .editable-cell-input-wrapper,
  .score-display-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .score-input-group,
  .score-display {
    display: flex;
    align-items: center;

    .score-name {
      min-width: 80px;
      text-align: right;
      margin-right: 8px;
      font-size: 16px;
    }
  }

  .editable-cell-text-wrapper {
    width: 100%;
    padding: 5px 0;

    .score-display-group {
      cursor: pointer;

      &:hover {
        background-color: #f5f5f5;
      }
    }
  }

  .ant-input-number {
    width: 80px;

    &-handler-wrap {
      display: none;
    }
  }
}
</style>